const addBlack = {
    path: 'merchant_black/add',
    component: resolve => require(['@/pages/admin/aftersales/merchantBlack/addBlack/add'], resolve),
    meta: {
        requireAuth: true
    },
}

export default addBlack